var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 13.139 17.705",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.7808 0.089325c-0.1082-0.1191-0.3144-0.1191-0.4224 0-0.2599 0.2856-6.3584 7.0402-6.3584 11.046 0 4.1122 3.3402 6.5695 6.5695 6.5695s6.5694-2.4573 6.5694-6.5695c0-4.0059-6.0984-10.76-6.3581-11.046z",
    fill: "#000",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluid);
export default __webpack_public_path__ + "static/media/fluid.4ad67f4c193c351345a6ab5cf94f4658.svg";
export { ForwardRef as ReactComponent };